import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import "./ServicesPage.css";
import { LuShieldCheck, LuSprayCan, LuClipboardCheck, LuBug } from "react-icons/lu";

import serviceImg1 from "../components/images/services1.jpg";
import serviceImg2 from "../components/images/services2.jpg";
import serviceImg3 from "../components/images/services3.jpg";
import serviceImg4 from "../components/images/services4.jpg";
import serviceImg5 from "../components/images/services5.jpg";

const ServicesPage = () => {

    const serviceData = [

        {
            title: "General Pest Control",
            desc: "Safe and reliable protection against cockroaches, ants, spiders and common pests.",
            image: serviceImg1,
        },

        {
            title: "Anti-Termite Service",
            desc: "Advanced anti-termite treatments to protect homes, furniture and wooden structures.",
            image: serviceImg2,
        },

        {
            title: "Mosquito Master Service",
            desc: "Organic and chemical mosquito treatment solutions for healthy surroundings.",
            image: serviceImg3,
        },

        {
            title: "Rodent Management",
            desc: "Effective rodent removal and prevention using safe modern methods.",
            image: serviceImg4,
        },

        {
            title: "Micro Sterilization & Sanitization",
            desc: "Professional sanitization solutions for safer, cleaner and germ-free spaces.",
            image: serviceImg5,
        },

    ];

    const steps = [
        {
            icon: <LuClipboardCheck />,
            title: <>Initial Inspection &   <br />Evaluation </>,
            desc: "We carefully inspect your property to identify pest activity, entry points and affected areas."
        },
        {
            icon: <LuSprayCan />,
            title: " Initial Treatment",
            desc: "Advanced treatment methods are applied using modern and eco-conscious pest solutions."
        },
        {
            icon: <LuBug />,
            title: "Maintenance Plan",
            desc: "Regular monitoring and preventive solutions ensure long-term pest protection."
        },
        {
            icon: <LuShieldCheck />,
            title: <>Constant <br /> Improvement </>,
            desc: "Our pest control process is continuously improved for better safety and performance."
        }
    ];

    const faqData = [

        {
            q: "Is your pest control safe for children and pets?",
            a: "Yes, we use products that are safe for families and pets whn used as directed."
        },

        {
            q: "How often should pest control services be performed?",
            a: "We recommend regular treatments every 3-6 months, depending on the issue."
        },

        {
            q: "Do you offer eco-friendly pest control solutions?",
            a: "Yes, we provide eco-friendly options to minimize environmental impact."
        },

        {
            q: "What should I expect during a pest inspection?",
            a: "Expect a thorough inspection of your property to identify pests and risk areas."
        },

        {
            q: "Are your technicians licensed and insured?",
            a: "Yes, all our technicians are fully licensed and insured for your safety."
        },

        {
            q: " How long does a typical pest treatment take?",
            a: "Most treatments take 1-2 hours, depending on the size and severity of the problem."
        },

        {
            q: "What measures can I take to prevent future infestations?",
            a: "Keep your space clean, seal entry points, and schedule regular inspections."
        }

    ];
    const [openFaq, setOpenFaq] = useState(null);


    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(() => {

        AOS.init({
            duration: 1000,
            once: true,
        });

    }, []);

    useEffect(() => {

        const interval = setInterval(() => {

            setActiveIndex((prev) =>
                prev === serviceData.length - 1 ? 0 : prev + 1
            );

        }, 4500);

        return () => clearInterval(interval);


    }, [serviceData.length]);

    return (

        <div className="premium-services-page">

            <section className="premium-service-hero">

                <div className="premium-carousel-wrapper">

                    {serviceData.map((service, index) => (

                        <div
                            key={index}
                            className={
                                index === activeIndex
                                    ? "premium-carousel-slide active-slide"
                                    : "premium-carousel-slide"
                            }
                        >

                            {/* LEFT CONTENT */}

                            <div className="premium-service-content">

                                <span>OUR SERVICES</span>

                                <h1>{service.title}</h1>

                                <p>{service.desc}</p>

                                <div className="premium-slider-dots">

                                    {serviceData.map((_, dotIndex) => (

                                        <button
                                            key={dotIndex}
                                            className={
                                                activeIndex === dotIndex
                                                    ? "dot active-dot"
                                                    : "dot"
                                            }
                                            onClick={() =>
                                                setActiveIndex(dotIndex)
                                            }
                                        />

                                    ))}

                                </div>

                            </div>

                            <div className="premium-service-image-wrap">
                                <img
                                    src={service.image}
                                    alt="service"
                                    className={`premium-service-image slide-img-${index}`}
                                />

                            </div>
                        </div>

                    ))}

                </div>

            </section>

            {/* STEPS */}
            <section className="premium-steps-section">
                <div className="container">

                    <div className="premium-steps-heading text-center" data-aos="fade-up">

                        <h2>—  Our 4-Step Pest Protection Process —</h2>
                        <p>
                            Our systematic approach ensures long-term protection and effective pest removal.
                        </p>
                    </div>


                    <div className="row g-4 mt-3">

                        {steps.map((item, i) => (
                            <div className="col-lg-3 col-md-6" key={i} data-aos="fade-up" data-aos-delay={i * 120}>

                                <div className="premium-step-card">

                                    <div className="premium-step-icon">
                                        {item.icon}
                                    </div>

                                    <h5>{item.title}</h5>
                                    <p>{item.desc}</p>

                                </div>

                            </div>
                        ))}

                    </div>
                </div>
            </section>


            {/* SCOPE SECTION */}

            <section
                className="premium-scope-section"
                style={{
                    backgroundImage: `url(${serviceImg5})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >

                <div className="premium-dark-layer"></div>

                <div className="container position-relative">

                    <div
                        className="premium-scope-heading text-center"
                        data-aos="fade-up"
                    >

                        <h2>— Our Scope of Work —</h2>

                        <p>
                            Effective solutions for a cleaner and pest-free environment.
                        </p>

                    </div>

                    <div className="premium-scope-timeline">

                        {/* ITEM 1 */}

                        <div
                            className="premium-scope-item left"
                            data-aos="fade-right"
                        >

                            <div className="premium-scope-content-box">

                                <span>01</span>

                                <p>
                                    Extermination of General insects, rodents,
                                    termites, cockroaches, ants including flying
                                    insects within and around the boundary wall
                                    of all building's premises
                                </p>

                            </div>

                        </div>

                        {/* ITEM 2 */}

                        <div
                            className="premium-scope-item right"
                            data-aos="fade-left"
                        >

                            <div className="premium-scope-content-box">

                                <span>02</span>

                                <p>
                                    Pest Control for manholes, utility hole,
                                    cable chamber, maintenance hole,
                                    inspection chamber, access chamber,
                                    drain chamber within the boundary wall
                                    of building
                                </p>

                            </div>

                        </div>

                        {/* ITEM 3 */}

                        <div
                            className="premium-scope-item left"
                            data-aos="fade-right"
                        >

                            <div className="premium-scope-content-box">

                                <span>03</span>

                                <p>
                                    We provide a detailed report on all pesticides
                                    used, ensuring they meet standards and follow
                                    all necessary protocols for safety and compliance.
                                </p>

                            </div>

                        </div>

                    </div>

                </div>

            </section>

            {/* F & Q SECTION */}
            <section className="tp-faq-section">

                <div className="container">

                    <h2 className="tp-faq-heading">
                        — Frequently Asked Questions —
                    </h2>

                    <div
                        className="accordion tp-faq-wrapper"
                        id="tpFaqAccordion"
                    >

                        {faqData.map((item, index) => (

                            <div
                                className="accordion-item tp-faq-item"
                                key={index}
                            >

                                <h2 className="accordion-header">

                                    <button
                                        className={`accordion-button tp-faq-btn ${openFaq === index ? "" : "collapsed"
                                            }`}
                                        type="button"
                                        onClick={() =>
                                            setOpenFaq(openFaq === index ? null : index)
                                        }
                                    >
                                        {item.q}
                                    </button>

                                </h2>

                                <div
                                    className={`accordion-collapse collapse ${openFaq === index ? "show" : ""
                                        }`}
                                >

                                    <div className="accordion-body tp-faq-body">

                                        {item.a}

                                    </div>

                                </div>

                            </div>

                        ))}

                    </div>

                </div>

            </section>


        </div>
    );
};

export default ServicesPage;   